<template>
  <div :style="wrapStyle">
    <Spin size="large" fix v-if="loading"></Spin>
    <div class="track-wrap">
      <div class="state" @click="handleClickState">
        <div class="flex">
          <div class="live flex">{{playModeLabel}} <span style="margin-left:8px;">No.{{extra.carNo}}</span></div>
          <div class="flex" title="车牌号" style="margin-right: 8px;text-align:center;">
            <Icon size="10" custom="i-icon icon-licenseplate" style="margin-right:5px;" />{{extra.licenseNo}}
          </div>
          <div class="flex">
            <Icon style="margin-right:5px;" type="md-time" size="16" />
            <span>{{updateTime}}</span>
            <!-- <Time :time="updateTime" :type="updateTimeDisplayType" :interval="1" /> -->
          </div>
          <div class="flex" title="当前时速" style="margin-left: 10px;">
            <Icon size="16" type="md-speedometer" style="margin-right:5px;" />{{speedLabel}}</div>
          <div class="flex" title="里程" style="margin-left: 10px;text-align:center;">
            <Icon size="16" type="md-flag" style="margin-right:5px;" />{{mileageLabel}}</div>
          <div class="flex" title="时长" style="margin-left: 10px;text-align:center;">
            <Icon size="15" type="ios-time" style="margin-right:5px;" />{{durationLabel}}</div>
          <DatePicker v-model="timeRangePre" :start-date="datePickerStartDate" :editable="false" type="datetimerange" :options="datePickerOptions" class="track-datepicker" placement="bottom" @on-ok="handleloadRecord" @on-change="handleDatePickerChange"></DatePicker>
          <Tooltip content="退出历史轨迹" v-show="historyMode">
            <Icon style="margin-left:15px;" type="md-exit" size="16" @click.stop="handleExistHistory" />
          </Tooltip>
        </div>
        <div style="text-align: center; margin-top:6px;">{{address}}</div>
      </div>
<!--       <div class="state2">
        <div>
          <p class="address">{{address}}</p>
          <div class="">
            <div class="flex" title="当前时速" style="margin-left: 10px;">
              <Icon size="16" type="md-speedometer" style="margin-right:5px;" />{{speedLabel}}</div>
            <div class="flex" title="里程" style="margin-left: 10px;text-align:center;">
              <Icon size="16" type="md-flag" style="margin-right:5px;" />{{mileageLabel}}</div>
          </div>
        </div>
        <div class="divider"></div>
      </div> -->
      <!-- <sl-amap-track ref="track" :style="mapStyle" @timeupdate="handleTick" /> -->
      <sl-amap :style="mapStyle" @ready="mapReady" />
      <div class="history-module" v-show="historyMode">
        <controller ref="controller" :timeRange="timeRange" :timepicker="timepicker" :metadata="metadata" @seeked="handleSeeked" @play="handlePlay" @change-speed="handleChangeSpeed" />
      </div>
      <div class="op">
        <!--         <Tooltip content="2D / 3D 切换">
          <Button :type="viewMode3D ? 'primary' : 'default'" shape="circle" icon="ios-albums-outline" @click="toggleViewmode"></Button>
        </Tooltip> -->
        <!--         <Tooltip content="切换驾驶模式">
          <Button :type="driveMode ? 'primary' : 'default'" shape="circle" icon="md-arrow-up" @click="toggleDriveMode"></Button>
        </Tooltip> -->
      </div>
      <Tooltip class="btn-fs" :content="fullScreenLabel">
        <Icon custom="i-icon icon-fullscreen" size="20" @click="handleFs" />
      </Tooltip>
    </div>
  </div>
</template>
<script>
import controller from './control'
import { datetime, timestamp, fullscreen,moment , duration} from '@/util'
import Track from '@/components/sl-amap/components/track'

export default {
  components: { controller },
  data() {
    return {
      carId: null,
      track: [],
      data: {},
      loading: true,
      currentId: null,
      historyRange: [],
      timeRange: [],
      timeRangePre:[],
      historyMode: false,
      historyPoint: 0,
      reqUpdateTime: 0,
      fullscreen: false,
      running: false,
      liveTimer: null,
      timepicker: false,
      liveData: null,
      address: null,
      mileage:null,
      duration:null,
      metadata: {
        currentProgress: 0,
        currentTime: '',
        duration: 1,
        speed: '--',
        playing: false,
        routes: []
      }
    }
  },

  computed: {
    carState() {
      return ''
    },
    updateTime() {
      if (this.historyMode) {
        if (this.metadata.currentTime) {
          return datetime(this.metadata.currentTime)
        } else {
          return '--/--/-- --:--:--'
        }
      } else {
        return datetime(this.reqUpdateTime || Date.now())
      }
    },
    speedLabel() {
      if (this.historyMode) {
        if (this.metadata.speed) {
          return this.metadata.speed + ' km/h'
        } else {
          return '-- km/h'
        }
      } else {
        if (this.liveData && this.liveData.speed) {
          return this.liveData.speed + ' km/h'
        } else {
          return '-- km/h'
        }
      }
    },

    mileageLabel() {
      if (this.mileage && this.mileage >= 0) {
        return Math.round(this.mileage*10)/10 + ' km'
      } else {
        return '-- km'
      }
    },

    durationLabel(){
      if (this.duration) {
        return duration(this.duration)
      } else {
        return 'n/a'
      }
    },

    updateTimeDisplayType() {
      if (this.historyMode) {
        return 'datetime'
      } else {
        return 'relative'
      }
    },
    fullScreenLabel() {
      return this.fullscreen ? '退出全屏' : '全屏'
    },
    mapStyle() {
      if (this.fullscreen) {
        return {
          width: '100vw',
          height: '100vh'
        }
      } else {
        return {
          height: '80vh'
        }
      }
    },
    wrapStyle() {
      if (this.fullscreen) {
        return {
          position: 'fixed',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
        }
      } else {
        return {

        }
      }
    },
    playModeLabel() {
      if (this.historyMode) {
        return 'REC'
      } else {
        return 'LIVE'
      }
    },
    datePickerStartDate(){
      if(this.limit.length){
        return moment(this.limit[0],'date')
      }
    },
    datePickerOptions(){
      let limit = (this.limit || []).filter(i => !!i)
      if(limit.length == 1){
        return {
          disabledDate: (date) => ( moment(date,'yyyy-MM-dd') < moment(limit[0],'yyyy-MM-dd') )
        }

      }else if(limit.length == 2){
        return {
          disabledDate: (date) => ( moment(date,'yyyy-MM-dd') < moment(limit[0],'yyyy-MM-dd') ||  moment(date,'yyyy-MM-dd') > moment(limit[1],'yyyy-MM-dd') )
        }
      }else{
        return {}
      }
    }
  },

  props: {
    id: {
      type: [Number, String]
    },
    extra:{
      type:Object,
      default(){
        return {}
      }
    },
    limit:{
      type:Array,
      default(){
        return []
      }
    },
  },
  watch: {
    timeRange(v) {
      if (v && v.length == 2) {
        //this.loadRecord(v)
      }
    }
  },
  created(){
    
  },
  mounted() {
    if (this.id) {
      this.init(this.id)
    }
  },
  beforeDestroy() {
    this.close()
  },
  methods: {
    init(id) {
      this.carId = id
      this.running = true

      if (location.search.includes('autoplay') && 1) {
        // console.log(moment('-1$d'),moment('+1d'))
        this.timeRangePre = [moment('$d') , moment('+1d')]
        this.handleloadRecord()
      }else{
        this.startLiveMode()
      }
    },

    mapReady(map) {
      this.tracker = new Track(map)
      this.tracker.on('timeupdate', this.handleTick.bind(this))
      this.tracker.on('address.update', this.addressUpdate.bind(this))
    },


    startLiveMode() {
      if (!this.running) return
      this.$request.locationHistory(this.carId, moment('+0d','yyyy-MM-dd 00:00:00'), moment('+1d','yyyy-MM-dd 00:00:00')).then(resp => {
        if( resp.data.length ){
          this.mileage = resp.data.reduce((t , i) => (t+ i.mileage || 0),0)
          this.duration = resp.data.reduce((t , i) => (t+ i.duration || 0),0)
          this.updateLiveTask(resp.data.pop())
        }else{
          this.mileage = 0
          this.duration = 0
          this.updateLiveTask()
        }
      })
    },

    updateLiveTask(lastRecord){
      let params = [this.carId]

      if(lastRecord){
        params.push(lastRecord.id)
      }else if(this.liveData){
        params.push(this.liveData.id)
      }

      this.$request.locationRealtime(...params).then(resp => {
        if (this.historyMode) return;

        resp.data = resp.data.filter(i => !!i)

        this.loading = false

        //更新数据有效
        let validUpdate = (resp.data && resp.data[0] && resp.data[0].latitude && resp.data[0].longitude)
        
        if(validUpdate){
          lastRecord = resp.data[0]
        }

        if (lastRecord) {
          this.tracker.setLive([lastRecord.longitude, lastRecord.latitude], lastRecord.speed, lastRecord.degrees, !(this.liveData && this.liveData.id))
          this.reqUpdateTime = new Date(timestamp(lastRecord.recordDatetime))
          
          if(validUpdate){
            this.mileage += resp.data.reduce((t , i) => ( t + (i.mileage || 0)) , 0)
            this.duration += resp.data.reduce((t , i) => ( t + (i.duration || 0)) , 0)
          }

          this.liveData = lastRecord
          this.liveTimer = setTimeout(()=>{
            this.updateLiveTask(lastRecord)
          }, 10 * 1000)
        } else {
          this.$Modal.warning({
            title: '警告',
            content: '暂无行驶记录',
            onOk: () => {
              this.$emit('close')
            }
          });
        }

      })
    },

    toggle() {
      this.historyMode = !this.historyMode
      if (this.historyMode == false) {
        this.tracker.stop()
        this.$refs['controller'].reset()
        this.metadata = {
          currentProgress: 0,
          currentTime: '',
          duration: 1,
          speed: '--',
          playing: false,
          routes: []
        }
        this.startLiveMode()
      } else {
        if(this.liveTimer){
          clearTimeout(this.liveTimer)
        }
        this.$refs['controller'].play()
      }
    },

    loadRecord(start, end) {
      this.loading = true
      this.$request.locationHistory(this.carId, start, end).then(resp => {
        resp.data = resp.data.filter(i => (i.latitude && i.longitude))
        if (resp.code == 0 && resp.data.length > 3) {
          this.historyMode = true
          this.track = resp.data.filter(i => (i.latitude && i.longitude)).map(i => ([i.longitude, i.latitude, datetime(i.recordDatetime), i.degrees, i.speed]))

          this.mileage = resp.data.reduce((t , i) => (t+ i.mileage || 0),0)
          this.duration = resp.data.reduce((t , i) => (t+ i.duration || 0),0)

          this.tracker.play(this.track)
          this.metadata.routes = this.track.map(i => i[2])
          this.metadata.duration = this.track.length - 1
          this.metadata.playing = true
          this.timepicker = false
        } else {
          this.$Notice.error({
            title: '提示',
            desc: '当前时段内没有行驶数据',
          });
        }

        this.loading = false
      })
    },

    close() {
      this.historyMode = false
      this.running = false
      this.loading = true
      if (this.liveTimer) {
        clearTimeout(this.liveTimer)
      }
      this.tracker.destroy()
      this.$refs['controller'].reset()
    },

    addressUpdate(e , address) {
      this.address = address
    },

    handleReady() {

    },
    handleClickState() {
      if (!this.historyMode) {
        // this.toggle()
        this.timepicker = true
      } else {
        this.timepicker = true
        // this.timepicker = !this.timepicker
      }

    },
    handleExistHistory() {
      this.toggle()
      this.timepicker = false
    },
    //检测是否在有效时段内
    dateLimitCheck(range){
      let limit = this.limit.filter(i => !!i)
      let result = true
      range = range.filter(i => !!i)
      if(range.length !=2){
        return false
      }
      if(limit.length == 2){
        result = moment(range[0],'ms') >= moment(limit[0],'ms') && moment(range[1],'ms') <= moment(limit[1],'ms')
        if(!result){
          this.$Notice.error({
            title: '提示',
            desc: `仅限查看 ${moment(limit[0],'yyyy-MM-dd hh:mm:ss')} 至 ${moment(limit[1],'yyyy-MM-dd hh:mm:ss')} 时段内的历史轨迹`,
          });
        }
      }else if(limit.length == 1){
        result = moment(range[0],'ms') >= moment(limit[0],'ms')
         if(!result){
         this.$Notice.error({
            title: '提示',
            desc: `仅限查看 ${moment(limit[0],'yyyy-MM-dd hh:mm:ss')} 以后的历史轨迹`,
          });
        }
      }

      return result 
    },
    handleDatePickerChange(a){
      this.dateLimitCheck([...a])
    },
    handleloadRecord(r) {
      //检测时段
      let timeRangePre = this.timeRangePre
      if (timeRangePre && timeRangePre.length == 2) {
        if(this.dateLimitCheck(timeRangePre)){
          this.timeRange = this.timeRangePre.map(datetime)
          this.loadRecord(this.timeRange[0], this.timeRange[1])
        }
        
      }
    },

    handlePlay() {
      this.metadata.playing = !this.metadata.playing

      if (this.metadata.playing) {
        this.tracker.play()
      } else {
        this.tracker.pause()
      }
    },
    handleChangeSpeed(rate) {
      this.tracker.setRate(rate)
    },

    handleFs() {
      this.fullscreen = !this.fullscreen
    },
    //位置更新
    handleTick(e, i) {
      this.metadata.currentProgress = i[1]
      this.metadata.currentTime = i[2]
      this.metadata.speed = i[4]
    },

    //拖动进度条时
    handleSeeked(position) {
      this.tracker.seekTo(position)
    }
  }
}

</script>
<style lang='scss'>
.track-wrap {
  position: relative;
  width: 100%;
  height: 100%;


  .flex {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .state2 {
    outline: none;
    position: absolute;
    display: inline-block;
    z-index: 2;
    background-color: rgba(34, 34, 34, .8);
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    top: 8px;
    color: #ccc;
    padding: 12px 15px;

    .address {
      font-size: 12px;
      color: #fff;
    }

    .divider {
      height: 1px;
      width: 100%;
      background-color: rgba(204, 204, 204, 0.3);
      margin: 4px 0 0 2px;
    }
  }

  .state {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
    width: fit-content;
    max-width: 650px;
    padding: 6px 15px;
    background: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .1);
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    cursor: pointer;
    font-size: 11px;

  }

  .op {
    position: absolute;
    right: 0;
    bottom: 30px;
    padding: 10px;

    &>* {
      display: block;
      margin-bottom: 8px;
    }
  }

  .history-panel {
    position: absolute;
    top: 10px;
    left: 50px;
    background: #fff;
    padding: 6px 10px;
    box-shadow: 0 0 3px rgba(0, 0, 0, .1);
  }

  .live {
    color: #333;
    display: flex;
    align-items: center;
    margin-right: 10px;

    &:before {
      content: ' ';
      width: 12px;
      height: 12px;
      display: inline-block;
      border-radius: 6px;
      background: rgb(246, 52, 52);
      margin-right: 5px;
    }
  }

  .btn-fs {
    position: absolute;
    top: 15px;
    right: 35px;
  }

  .track-datepicker {
    position: absolute;
    // top: 10%;
    // left: 50%;
    // transform: translateX(-50%);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    // opacity: 0;pointer-events: none;
    .ivu-date-picker-rel {
      opacity: 0;
      cursor: pointer;
    }
  }
}

</style>
